/**
 * Floorplan colors of the plan PDF export, for the "Positionsplan" / "Aussteifungsplan" coloring
 * modes. Mirrors `server/src/md_core/functions/export/plans/pdf/pypdf.py` and
 * `pdf/position_plan_colors.py` — keep in sync when the export colors change. Beams, purlins and
 * the ceiling / column outlines already use the export colors by default.
 */

export type PlanColoringMode = Extract<ColoringMode, 'positionPlan' | 'stiffeningPlan'>

export interface PlanWallColors {
  fill: string
  outline: string
  openingFill: string
  openingOutline: string
}

export const PLAN_WALL_COLORS: Record<PlanColoringMode, PlanWallColors> = {
  // All walls are exported as bearing (`BEARING_WALL_FOOTPRINT_*`).
  positionPlan: {
    fill: '#E6E6E6',
    outline: '#000000',
    openingFill: '#FFFFFF',
    openingOutline: '#999999',
  },
  // `STIFFENING_PLAN_WALL_FOOTPRINT_*`
  stiffeningPlan: {
    fill: '#FFFFFF',
    outline: '#000000',
    openingFill: '#FFFFFF',
    openingOutline: '#999999',
  },
}

/** Column and wall rip footprints are white boxes (`*_FOOTPRINT_BACKGROUND_COLOR_HEX`). */
export const PLAN_FOOTPRINT_FILL = '#FFFFFF'

/** Roof positions are outlined in the ceiling blue (`ROOF_POSITION_COLOR_HEX`). */
export const PLAN_ROOF_POSITION_OUTLINE = '#2512FF'

/**
 * Fill opacities matching the export: ceilings and roof positions are outlines only, column and
 * wall rip footprints are opaque.
 */
export const PLAN_COLORING_OPACITY: Partial<Record<ElementTypes, number>> = {
  vertical_slabs: 0,
  vertical_roof_slabs: 0,
  columns: 1,
  rips: 1,
}

export const isPlanColoringMode = (mode: ColoringMode): mode is PlanColoringMode =>
  mode === 'positionPlan' || mode === 'stiffeningPlan'
